import api from './api';

const listReports = (clientId) => {
  return api.get(`/reports/${clientId}`);
};

const downloadReport = (s3Key) => {
  return api.get(`/reports/download/${s3Key}`, {
    responseType: 'blob',
  });
};

const generateDocxReport = (clientId, reportType, granularity) => {
  // El cuerpo del POST ahora enviará los parámetros
  return api.post(`/reports/generate-docx/${clientId}`, {
    report_type: reportType,
    granularity: granularity,
  });
};

const getAvailableReportTypes = (clientId) => {
  return api.get(`/reports/available-types/${clientId}`);
};

const deleteReport = (s3Key) => {
  return api.delete(`/reports/${s3Key}`);
};

const previewReport = (s3Key) => {
  return api.get(`/reports/preview/${s3Key}`);
};

const reportService = {
  listReports,
  downloadReport,
  generateDocxReport,
  getAvailableReportTypes,
  deleteReport,
  previewReport,
};

export default reportService;